import { MarkerClusterer } from '@googlemaps/markerclusterer';

class GoogleMaps {

  constructor() {
    var prev_infowindow = false; 
    let map;
    let markers = [];
    let mapToStyles = [
      {
        'featureType': 'landscape',
        'elementType': 'all',
        'stylers': [
          {
            'color': '#dee6b0'
          }
        ]
      },
      {
        'featureType': 'landscape.man_made',
        'elementType': 'all',
        'stylers': [
          {
            'color': '#efd189'
          }
        ]
      },
      {
        'featureType': 'poi',
        'elementType': 'all',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        'featureType': 'road.highway',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'color': '#ffffff'
          }
        ]
      },
      {
        'featureType': 'road.highway',
        'elementType': 'geometry.stroke',
        'stylers': [
          {
            'color': '#f8ea1b'
          }
        ]
      },
      {
        'featureType': 'water',
        'elementType': 'all',
        'stylers': [
          {
            'color': '#7ecff5'
          }
        ]
      }
    ];
    let singleDestination = document.querySelectorAll('.destination.single');

    function initMap() {
      // let disableDefaultUI = (2 > singleDestination.length) ? true : false;

      map = new google.maps.Map(document.getElementById('map'), {
        center: { lat: 55.995309, lng: 13.441772 },
        zoom: 9,
        // disableDefaultUI: disableDefaultUI, // commented this one out to get the zoom buttons on the map
        fullscreenControl: false,
        streetViewControl: false,
        styles: mapToStyles,
      });

       setMarkers(map);
      // centerMap(map);  //removed this function because when you reload the besokmal page the google map is maxed zoomed out and does not behave as we want.
      loadKMLs(map);

    }

    function setMarkers(map) {
      let locations = document.querySelectorAll('.destination');
      let infoWindow = new google.maps.InfoWindow();

      if (markers.length) {
        markers = [];
      }

      if (0 < locations.length) {

        locations.forEach((location) => {
          let iconFilename = ('true' == location.dataset.member) ? 'icon-marker-member.png' : 'icon-marker.png';

          let marker = new google.maps.Marker({
            position: {
              lat: parseFloat(location.dataset.lat),
              lng: parseFloat(location.dataset.lng)
            },
            icon: {
              url: '/wp-content/themes/visitmittskane/assets/dist/images/' + iconFilename,
              size: new google.maps.Size(38, 39),
              anchor: new google.maps.Point(19, 19),
              scaledSize: new google.maps.Size(38, 39)
            },
            map
          });

          const headline = location.querySelector('h3').innerText;
          let imageSrc = "";
          if (!location.querySelector('img')) {
            return
          }
          else if (location.querySelector('img').getAttribute("src") != "" || location.querySelector('img').getAttribute("src") != null ) {
            imageSrc = location.querySelector('img').src;

          } else {
            imageSrc = "";
          }
        
        
          let isMember = location.getAttribute("data-member");
          let memberHtml = "";
          if (isMember == "true") {
            memberHtml = '<p class="pill-text badge rounded-pill mt-2 me-3 text-white bg-dark">' + "Utvald" + '</p>'
          } else {
            memberHtml = "";
          }

          let categories = location.getAttribute("data-category");
          
          let isTargetBlank = "";
          if (isMember == "false") {
            isTargetBlank = "_blank";
          } else {
            isTargetBlank = "";
          }

           let linkToDestination = location.getAttribute('href', '_blank');
          
          
          const contentString =
          '<div class="card mb-3" style="width: 327px;">' + 
          '<div class="border-none d-flex" style="height: 114px;">' +
            '<div class="text-center align-self-center" style="margin-left: 1rem;">' +
            `<img src="${imageSrc}" class="gm-image" style="height: 82px; width: 82px;">` +
            '</div>' +
            '<div class="col-md-8">' +
              '<div class="card-body">' +
                '<p class="card-title card-title-text">' + `${categories}` + '</p>' +
                '<p class="card-text">' + `${headline}` + '</p>' +
                `${memberHtml}` +
                `<a href="${linkToDestination}" target="${isTargetBlank}">` + 
                `<img src="/wp-content/themes/visitmittskane/assets/dist/images/gm-gotopage.png" class="gm-goto">` +
                `</a>`+ 
              '</div>' + 
            '</div>' +
          '</div>' +
        '</div>';

          const infowindow = new google.maps.InfoWindow({
            content: contentString,
          });
          
          markers.push(marker);

          

          google.maps.event.addListener(marker, 'click', function () {
            if( prev_infowindow ) {
              prev_infowindow.close();
            }
            prev_infowindow = infowindow;
            
          infowindow.open({
            anchor: marker,
            map,
            shouldFocus: false,
          })
          });
        });

      }

      // new MarkerClusterer({ markers, map, renderer });
    }

    function centerMap(map) {
      let zoomLevel = (2 < singleDestination.length) ? 10 : 12;
      let bounds = new google.maps.LatLngBounds();

      if (0 < markers.length) {

        markers.forEach((marker) => {

          bounds.extend({
            lat: marker.getPosition().lat(),
            lng: marker.getPosition().lng()
          });
        });


        if (bounds && (bounds.getCenter().lat() && bounds.getCenter().lng())) {
          if (1 == markers.length) {
            map.setCenter(bounds.getCenter());
            map.setZoom(zoomLevel);
          } else {
            map.fitBounds(bounds, 64);
          }
        }
      }
    }

    window.initMap = initMap;

    if (map) {

      window.addEventListener('resize', _.throttle(() => {
        centerMap(map);
      }, 16), false);
    }


    function loadKMLs(map) {
      var src = window.location.origin + '/wp-content/uploads/kml/visitmittskane.kmz';

      var kmlLayer = new google.maps.KmlLayer(src, {
        suppressInfoWindows: false,
        preserveViewport: true,
        map: map
      });

      // kmlLayer.addListener('click', function (event) {
      //   var content = event.featureData.infoWindowHtml;
      //   var testimonial = document.getElementById('capture');
      //   testimonial.innerHTML = content;
      // });

      // if (window.location.href.includes('mina-favoriter')) {
      // 	let srcs = ['pilgrimsleden.kml', 'reg_bstad_ystad.kml', 'reg_kstad_lomma.kml', 'skaneleden.kml', 'sydkustleden.kml', 'sydostleden.kml'];
      // 	const prefix = window.location.origin + '/';
      // 	srcs.forEach(src => {
      // 		let kmlLayer = new google.maps.KmlLayer(prefix + src, {
      // 			suppressInfoWindows: true,
      // 			preserveViewport: false,
      // 			map: map
      // 		});
      // 	});
      // }
    }

  }
}

export default GoogleMaps;
